// extracted by mini-css-extract-plugin
module.exports = {"root":"Qualiphy_root__rVcc-","boxTitle":"Qualiphy_boxTitle__36Wa9","box":"Qualiphy_box__18vH2","toggleWrap":"Qualiphy_toggleWrap__37LVu"};